import { faFile } from "@fortawesome/free-solid-svg-icons";
import ItemCard from "../../../../shared/ItemCard";

export default function ReferenceCard({ item, sectionId }: any) {
  return (
    <ItemCard href={`/references/${sectionId}/${item.id}`}>
      <ItemCard.Image src={item.image_url} fallbackIcon={faFile} />
      <ItemCard.Content>
        <ItemCard.Title>
          {item.title}
        </ItemCard.Title>
        {item.text_preview && (
          <ItemCard.Description>
            {item.text_preview}
          </ItemCard.Description>
        )}
        <ItemCard.Actions>
          <div></div>
          <button
            className="btn btn-primary btn-sm"
          >
            Read more
          </button>
        </ItemCard.Actions>
      </ItemCard.Content>
    </ItemCard>
  );
}
